import { axios } from '@/services/axios';

export const assignRegistrarToCompany = (registrarId, companyId) => {
    const endpoint = `/TRSRegistrar/${registrarId}/Company/${companyId}`;
    const res = axios.post(endpoint);
    return res;
};
